export default "__VITE_ASSET__94353758__"